/*
 * Http访问接口封装
 */

'use strict'

import axios from 'axios'
import { Toast } from 'vant';
/**
 * axios 设置默认值
 * @type {string}
 */

// axios.defaults.baseURL = 'https://mall-test.pkt360.com'  // 测试
axios.defaults.baseURL = 'https://mallapi.pkt360.com'  // 线上


axios.defaults.timeout = 30000; // 30秒超时
axios.defaults.withCredentials = false;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.post['Accept'] = 'application/json';
axios.defaults.responseType = 'json';

axios.defaults.headers.common['Authorization'] = "";

/*
 * 请求拦截
 * 通过request 拦截器，可以需要的参数传到服务端
 * 示例为获取Cookie中存储的session传输到后台
 */
axios.interceptors.request.use(
    config => {
        
        // 设置请求头token
        let sessionId = localStorage.getItem('sessionId')

        if (sessionId) {
           config.headers['token'] = sessionId;
        }

        return config
    },
    err => {
        return Promise.reject(err)
    }
)

/*
 * 响应拦截
 */
axios.interceptors.response.use(
    response => {
        
        if (response) {
            // 响应处理
            // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
            // 否则的话抛出错误
            if (response.status === 200) {
                // console.log(response)
                if(response.data){
                    if(response.data.status==2){  
                        localStorage.removeItem('sessionId')
                        Toast({
                            message: response.data.msg,
                            overlay: 'true',
                            duration: 3 * 1000,
                            onClose: function () {}
                        })
                    }else if(response.data.status==3){
                        localStorage.removeItem('sessionId')
                        Toast({
                            message: '此账号已在其他设备上登录！',
                            overlay: 'true',
                            duration: 3 * 1000,
                            onClose: function () {}
                        })
                    }else if(response.data.status==1){  //其他错误
                        // console.log(response.data.msg)
                        localStorage.setItem('sessionId',response.data.token) 
                        Toast({
                            message:  response.data.msg,
                            overlay: 'true',
                            duration: 3 * 1000,
                            onClose: function () {}
                        })
                    }else if(response.data.status==0){  //返回正常
                        localStorage.setItem('sessionId',response.data.token)    
                    }
                }
                return Promise.resolve(response)
            } else {
                return Promise.reject(response)
            }
        }
        
        return response
    },
    error => {
        // 根据和后台开发人员协商好的错误状态码，进行相应的错误处理
        // 几个常见的操作处理
        if(error&&error.response){
            switch (error.response.status) {
                case 403:
                    error.message = '拒绝访问(403)'; break
                case 404:
                    error.message = '请求出错(404)'; break
                case 500:
                    error.message = '服务器错误(500)'; break
                case 501:
                    error.message = '服务未实现(501)'; break
                case 502:
                    error.message = '网络错误(502)'; break
                case 503:
                    error.message = '服务不可用(503)'; break
                case 504:
                    error.message = '网络超时(504)'; break
                case 505:
                    error.message = 'HTTP版本不受支持(505)'; break
                default:
                    error.message = `连接出错(${error.response.status})!`
            }
        }
        Toast({
            message: error.message,
            overlay: 'true',
            duration: 3 * 1000,
            onClose: function () {}
        })
        return Promise.reject(error)
    }
)

/**
 * get请求
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 * @returns {Promise}
 */
export function get(url, params) {
    url = url + '?v=' + Math.random();

    return new Promise((resolve, reject) => {
        axios.get(url, { params: params }).then((res) => {
            resolve(res.data)
        }).catch((error) => {
            reject(error.data)
        })
    })
}

/*
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {Object} data [请求时携带的body数据]
 */
export function post(url, data) {
    return new Promise((resolve, reject) => {
        axios.post(url, data).then((res) => {
            resolve(res.data)
        }).catch((error) => {
            reject(error.data)
        })
    })
}
